import { createBooleanDevicePreference } from './devicePreference';

// Per-device switch for the history pill's blink (LG-49). Default ON: the
// signal only fires on an exercise the athlete has actually been away from,
// so an install that starts with it off would never show the one thing it
// was built to show.
//
// ⭐ It exists because Antenore asked for the valve in the same breath as the
// blink (2026-09-01): the pulse stays intermittent — *«come tutte le altre»* —
// precisely BECAUSE there is a way to stop it. The two are one decision, and
// the shortcut in the history panel's header is the third half of it: a
// setting nobody can find is a setting nobody has
// ([[feedback_a_guard_that_blocks_gets_worked_around]] — you change who
// decides, not what the control says).
//
// ⛔ The switch silences the BLINK, never the pill. The age itself is written
// in words and stays on screen either way: turning down the volume must not
// cost the athlete the fact.
const pref = createBooleanDevicePreference(
  'jackedlogs.exerciseAgePulse.v1.enabled',
  true,
);

export const useExerciseAgePulseEnabled = pref.usePreference;
